module.exports = __webpack_public_path__ + "img/student-astronaut.6a5aa97e.svg";